module.exports = __webpack_public_path__ + "img/app_03.004aa675.jpg";